import cardsStyles from '../../styles/components/cards';

const style = {
  filtersPanel: {
    ...cardsStyles.card,
    boxSizing: 'border-box',
    padding: '15px 20px',
  },
  filtersPanel__container: {
    'display': 'flex',
    'justifyContent': 'flex-start',
    'alignItems': 'center',
    'gap': '12px',
    '@media (max-width: 500px)': {
      flexDirection: 'column',
    },
  },
  filtersPanel__itemFromControl: {
    padding: 0,
  },
};

export default style;
